/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WellnessInputs */

const en_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wellness`)
};

const es_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienestar`)
};

const fr_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bien-être`)
};

const de_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wellness`)
};

const ja_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウェルネス`)
};

const zh_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康护理`)
};

const ar_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صحة وعافية`)
};

const id_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesehatan`)
};

const it_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benessere`)
};

const ru_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товары для здоровья`)
};

const pt_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-estar`)
};

const ko_val_wellness = /** @type {(inputs: Val_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`웰니스`)
};

/**
* | output |
* | --- |
* | "Wellness" |
*
* @param {Val_WellnessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_wellness = /** @type {((inputs?: Val_WellnessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WellnessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_wellness(inputs)
	if (locale === "es") return es_val_wellness(inputs)
	if (locale === "fr") return fr_val_wellness(inputs)
	if (locale === "de") return de_val_wellness(inputs)
	if (locale === "ja") return ja_val_wellness(inputs)
	if (locale === "zh") return zh_val_wellness(inputs)
	if (locale === "ar") return ar_val_wellness(inputs)
	if (locale === "id") return id_val_wellness(inputs)
	if (locale === "it") return it_val_wellness(inputs)
	if (locale === "ru") return ru_val_wellness(inputs)
	if (locale === "pt") return pt_val_wellness(inputs)
	return ko_val_wellness(inputs)
});